import styled from 'styled-components';
import {GlobalFonts} from '../../globals';

export const CardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 28px;
  @media(min-width: 0px) and (max-width: 870px){
    display: block;
  }
`;

export const Card = styled.div`
  width: calc(33.333% - 19px);
  max-width: calc(33.333% - 19px);
  background-color: #f1f1f3;
  border: none;
  border-radius: 24px;
  margin: 0;
  padding: 40px 38px 34px 38px;
  box-sizing: border-box;
  min-height: 290px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  @media(min-width: 0px) and (max-width: 750px){
    height: auto;
  }
  @media(min-width: 0px) and (max-width: 870px){
    padding: 28px 24px;
    max-width: none;
    width: 100%;
    min-height: auto;
    margin-bottom: 16px;
  }
  @media(min-width: 820px) and (max-width: 970px) {
    padding: 20px;
  }
`;

export const Icon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #1f69cf;
  font-size: 24px;
  line-height: 1;
  margin-right: 14px;

  & > img {
    width: 22px;
    height: 22px;
    object-fit: contain;
  }
`;

export const CardTitle = styled.div`
  display: flex;
  align-items: center;
  min-height: 38px;
  margin: 0 !important;
  padding-left: 0;
  text-align: left;
  justify-content: flex-start;
`;

export const Title = styled.div`
  font-size: 26px;
  font-family: ${GlobalFonts.fontBold};
  color: #1f69cf;
  margin: 0;
  text-align: left;
  line-height: 1.2;

  @media(min-width: 0px) and (max-width: 399px){
    font-size: 20px;
  };

  @media(min-width: 400px) and (max-width: 767px){
    font-size: 22px;
  };
  @media(min-width: 768px) and (max-width: 1024px){
    font-size: 23px;
  }
  @media(min-width: 1025px) and (max-width: 1200px){
    font-size: 24px;
  }
`;

export const CardDescription = styled.div`
  font-size: 18px;
  line-height: 1.35;
  font-family: ${GlobalFonts.fontRegular};
  color: #4b4b4b;
  vertical-align: middle;
  margin-top: 28px;
  text-align: left;

  @media(min-width: 400px) and (max-width: 767px){
    font-size: 18px;
    line-height: 1.4;
  }
  @media(min-width: 768px) and (max-width: 1024px){
    font-size: 17px;
    line-height: 1.4;
  }
  @media(min-width: 1025px) and (max-width: 1200px){
    font-size: 17px;
    line-height: 1.35;
  }
`;

export const RoundButton = styled.button`
  background-color: #0073e6;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
